const sendGetVersion = () => {
	if (navigator?.serviceWorker?.controller) {
		navigator?.serviceWorker?.controller.postMessage({
			type: 'getVersion',
		});
	}
};

export function register() {
	// Skip service worker in development so refresh always loads latest bundle (no stale cache)
	if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_DEV_MODE === 'LOCAL') {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.getRegistrations().then((registrations) => {
				registrations.forEach((r) => r.unregister());
			});
		}
		return;
	}
	const swPath = `${process.env.PUBLIC_URL}/sw-v5.js?version=05`;
	const url =
		process.env.REACT_APP_ENVIRONMENT === 'production'
			? 'https://app.floik.com'
			: 'https://us.realmofdev.com';
	const allowedDomain = process.env.REACT_APP_URL || url;

	if ('serviceWorker' in navigator && window.location.origin === allowedDomain) {
		window.addEventListener('load', function () {
			navigator.serviceWorker
				.register(swPath, {
					scope: allowedDomain,
				})
				.then(
					function (registration) {
						registration.onupdatefound = () => {
							const installingWorker = registration.installing;
							if (installingWorker == null) {
								return;
							}
							installingWorker.onstatechange = () => {
								if (installingWorker.state === 'activated') {
									sendGetVersion();
									location.reload();
								}
								if (installingWorker.state === 'installing') {
								}
								if (installingWorker.state === 'installed') {
									if (navigator?.serviceWorker?.controller) {
										navigator?.serviceWorker?.controller.postMessage({
											type: 'skipWaiting',
										});
										// Unregister the existing service worker and activate the new one
										registration.unregister();
									}
								}
							};
						};
						sendGetVersion();
						// Registration was successful
					},
					function (err) {
						// registration failed :(
					}
				);
		});
	}
}
